import { render, staticRenderFns } from "./SuspiciousCheckIns.vue?vue&type=template&id=61aa539e&scoped=true"
import script from "./SuspiciousCheckIns.vue?vue&type=script&lang=js"
export * from "./SuspiciousCheckIns.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousCheckIns.vue?vue&type=style&index=0&id=61aa539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa539e",
  null
  
)

export default component.exports